import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useNavigate } from '../../Pages/navigation'
import { useIsLoggedIn } from '../../state/hooks/ActiveUserHooks'

export const useRedirectLoggedOut = () => {
	const isLoggedIn = useIsLoggedIn()
	const location = useLocation()
	const goToLoginPage = useNavigate('login')

	const whitelist = [
		'/',
		'/registration/credentials',
		'/registration/confirmation/email',
		'/forgot-password',
		'/forgot-password/code',
		'/invite',
		'/public',
		'/public/games',
		'/public/game',
	]

	const exec = () => {
		if (!whitelist.includes(location.pathname) && !isLoggedIn) {
			goToLoginPage()
		}
	}

	useEffect(() => {
		exec()
	}, [])

	useEffect(() => {
		exec()
	}, [isLoggedIn, location])
}
